import { SET_USERS, SET_ROLES, SET_PERMISSIONS } from "../mutation-types";
import userResource from "../../api/userResource";
import roleResource from "../../api/roleResource";
import { ActivityTypes } from "../../api/activityResource";

const userState = () => ({
  users: [],
  roles: [],
  permissions: [],
});

const mutations = {
  /**
   *
   * @param {*} state
   * @param {*} users
   */
  [SET_USERS]: (state, users) => {
    state.users = users;
  },
  [SET_ROLES]: (state, roles) => {
    state.roles = roles;
  },
  [SET_PERMISSIONS]: (state, permissions) => {
    state.permissions = permissions;
  },
};

const actions = {
  loadusers({ commit }) {
    return new Promise((resolve, reject) => {
      userResource
        .getAll()
        .then((res) => {
          // console.log(res);
          commit(SET_USERS, res.data.results);
          resolve();
        })
        .catch((error) => reject(error));
    });
  },
  getUser(_, id) {
    return new Promise((resolve, reject) => {
      userResource
        .get(id)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => reject(error));
    });
  },
  loadroles({ commit }) {
    return new Promise((resolve, reject) => {
      roleResource
        .list()
        .then((res) => {
          // console.log(res);
          commit(SET_ROLES, res.data.results);
          resolve();
        })
        .catch((error) => reject(error));
    });
  },

  updateUser({ dispatch }, { id, user }) {
    return new Promise((resolve, reject) => {
      userResource
        .updateOne(id, user)
        .then(() => {
          dispatch("loadusers");
          // Log user update activity
          dispatch(
            "activity/logActivity",
            {
              type: ActivityTypes.USER_UPDATED,
              entityType: "user",
              entityId: id,
              entityName: user.username || user.email,
              details: { targetUserId: id },
            },
            { root: true }
          );
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  deleteUser({ dispatch }, id) {
    return new Promise((resolve, reject) => {
      userResource
        .destroy(id)
        .then(() => {
          dispatch("loadusers");
          // Log user deletion activity
          dispatch(
            "activity/logActivity",
            {
              type: ActivityTypes.USER_DELETED,
              entityType: "user",
              entityId: id,
              details: { targetUserId: id },
            },
            { root: true }
          );
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  createRole({ dispatch }, role) {
    return new Promise((resolve, reject) => {
      roleResource
        .store(role)
        .then(() => {
          dispatch("loadroles");
          // Log role creation activity
          dispatch(
            "activity/logActivity",
            {
              type: ActivityTypes.ROLE_CREATED,
              entityType: "role",
              entityName: role.name,
              details: { roleName: role.name },
            },
            { root: true }
          );
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  deleteRole({ dispatch }, id) {
    return new Promise((resolve, reject) => {
      roleResource
        .destroy(id)
        .then(() => {
          dispatch("loadroles");
          // Log role deletion activity
          dispatch(
            "activity/logActivity",
            {
              type: ActivityTypes.ROLE_DELETED,
              entityType: "role",
              entityId: id,
              details: { roleId: id },
            },
            { root: true }
          );
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateRole({ dispatch }, { id, role }) {
    return new Promise((resolve, reject) => {
      roleResource
        .update(id, role)
        .then(() => {
          dispatch("loadroles");
          // Log role update activity
          dispatch(
            "activity/logActivity",
            {
              type: ActivityTypes.ROLE_UPDATED,
              entityType: "role",
              entityId: id,
              entityName: role.name,
              details: { roleId: id, roleName: role.name },
            },
            { root: true }
          );
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateUserRole({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      userResource
        .updateRole(data)
        .then(async () => {
          await dispatch("loadusers");
          // Log user role change activity
          dispatch(
            "activity/logActivity",
            {
              type: ActivityTypes.USER_ROLE_CHANGED,
              entityType: "user",
              entityId: data.user_id || data.userId,
              details: { newRole: data.group || data.role },
            },
            { root: true }
          );
          resolve();
        })
        .catch((error) => reject(error));
    });
  },

  // eslint-disable-next-line no-unused-vars
  createPermission({ dispatch }, perm) {
    return new Promise((resolve, reject) => {
      roleResource
        .createPermission(perm)
        .then(() => {
          // dispatch("loadPermissions");
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  loadPermissions({ commit }) {
    return new Promise((resolve, reject) => {
      roleResource
        .getPermissions()
        .then((res) => {
          // console.log(res);
          commit(SET_PERMISSIONS, res.data.results);
          resolve();
        })
        .catch((error) => reject(error));
    });
  },
};

export default {
  namespaced: true,
  state: userState,
  mutations,
  actions,
};
